import { DownloadProvider } from '../components/download/context/DownloadContext';
import DownloadView from '../components/download/DownloadView';

const Dashboard: React.FC = () => (
    <DownloadProvider>
        <DownloadView />
    </DownloadProvider>
);

export default Dashboard;
